// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"f16eb14bddb63de688a5","883":"b3a090f2a67b509f632d","954":"c0bceba97d809fa2dae6"}[chunkId] + ".js";
};